import responsiveCallback from "./responsiveCallback";

const $accordionItems = $('[data-accordion-collapse="1"]');

const accordionModifierClass = "m-block--accordion";
const accordionTitleClass = "m-block__accordion-title";
const accordionContentClass = "m-block__wrap";

const $win = $(window);

responsiveCallback(1140, isMobile => {
  isMobile ? initAccordion() : destroyAccordion();
});

function initAccordion() {
  $accordionItems.each(function forEachSection() {
    const $this = $(this);

    // add modifier and hide all content sections
    $this
      .addClass(accordionModifierClass)
      .find("." + accordionContentClass)
      .hide();

    // add accordion titles
    $this.children().prepend(`
      <div class="${accordionTitleClass}">
        ${$this.attr("data-accordion-title")}
      </div>
    `);
  });

  $('.' + accordionTitleClass).on('click', onAccordionTitleClick);
}

function destroyAccordion() {
  $('.' + accordionTitleClass).off();

  // remove accordion titles
  $accordionItems.find("." + accordionTitleClass).remove();

  // remove modifier and show all content sections
  $accordionItems
    .removeClass(accordionModifierClass)
    .find("." + accordionContentClass)
    .show();
}

function onAccordionTitleClick() {
  $(this)
    .toggleClass(`${accordionTitleClass}--opened`)
    // resize is required for responsive slider
    .next().slideToggle(200, () => { $win.trigger('resize'); });
}
